var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgAttachDocNew = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 9V16C6 19.3137 8.68629 22 12 22C15.3137 22 18 19.3137 18 16V8M6 15V6C6 3.79086 7.79086 2 10 2C12.2091 2 14 3.79086 14 6V15M10 6V16C10 17.1046 10.8954 18 12 18C13.1046 18 14 17.1046 14 16V13",
    stroke: "#7F8DA0",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAttachDocNew);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/attach-doc-new.8619e5695e04be8864233b9b961cc55b.svg";